import ShiftSelector from "./subcomponents/ShiftSelector";
import LoadPlanningTable from "./tables/crossBorder/loadPlanning";
import MiscNotesTable from "./tables/crossBorder/miscNotes";
import CrossBorderTrackAndTraceTable from "./tables/crossBorder/trackAndTrace";

const CrossBorder = () => {
    return (
        <>
            {/* <div className="main-container">
                <MiscNotesTable />
                <hr />
                <CrossBorderTrackAndTraceTable />
                <hr />
                <LoadPlanningTable />
                <hr />
            </div> */}
            <div className="main-container">
                    <div className="pulse-section pt-0 mt-3">
                        <div className="pulse-header">
                            <h1>Cross Border Briefing</h1>
                        </div>
                        <div className="pulse-body">
                            <p className="text-muted">Miscellaneous notes, Track & Trace, Load planning</p>
                            <hr />
                            <MiscNotesTable />
                            <hr />
                            <CrossBorderTrackAndTraceTable />
                            <hr />
                            <LoadPlanningTable />
                        </div>
                    </div>
            </div>
            <ShiftSelector />
        </>
    )
}

export default CrossBorder;